<template>
  <div id="app">
    <router-view></router-view>
    <GDPRBanner id="banner" />
  </div>
</template>

<script>
import GDPRBanner from '@/components/shared/GDPRBanner';

export default {
  name: 'App',
  components: {
    GDPRBanner,
  },
};
</script>

<style>
html, body, #app {
  height: 100%;
}

#banner {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
